import { environment } from 'projects/self-care/src/environments/environment';

/**
 * Joins an API media path with `baseUrl`, normalizing slashes and leaving
 * absolute / data / blob / assets URLs unchanged.
 */
export function resolveMediaUrl(path: string | null | undefined, baseUrl: string = environment.baseUrl): string {
  if (!path) {
    return '';
  }
  if (/^(https?:|data:|blob:)/i.test(path) || path.startsWith('assets/')) {
    return path;
  }
  const base = baseUrl.replace(/\/+$/, '');
  const relative = path.replace(/^\/+/, '');
  return `${base}/${relative}`;
}
